import { render } from "./JoinSocialPrompt.vue?vue&type=template&id=f89bfea8&scoped=true"
import script from "./JoinSocialPrompt.vue?vue&type=script&lang=js"
export * from "./JoinSocialPrompt.vue?vue&type=script&lang=js"

import "./JoinSocialPrompt.vue?vue&type=style&index=0&id=f89bfea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89bfea8"]])

export default __exports__